import { BsInstagram, BsTelegram } from "react-icons/bs";
import { Link } from "react-router-dom";
import Enamad from "../images/e-namad.png";
import Samandehi from "../images/samandehi.png";
import balle from "../images/balenew.png";

const BADGES = [
  { src: Enamad, alt: "نماد اعتماد الکترونیکی" },
  { src: Samandehi, alt: "ساماندهی" },
];

const SOCIALS = [
  {
    href: "https://ble.ir/madreseplus_ir",
    label: "بله",
    render: () => (
      <img className="w-7 rounded" src={balle} alt="" aria-hidden="true" />
    ),
  },
  {
    href: "https://www.instagram.com/madreseplus_ir?igsh=MXZpMnZxOGxmcWg0dg==",
    label: "اینستاگرام",
    render: () => <BsInstagram size={28} />,
  },
  {
    href: "https://t.me/madreseplusir",
    label: "تلگرام",
    render: () => <BsTelegram size={28} />,
  },
];

const Footer = () => (
  <footer className="mx-auto w-full bg-[#191919] px-4 pb-6 pt-3 md:px-12 lg:pb-4">
    <div className="justify-between gap-4 sm:flex sm:flex-row">
      <p className="mb-4 mt-1 leading-[1.3rem] text-[#8c8c90] sm:w-[85%] sm:leading-[1.8rem] md:w-[70%]">
        ما در نوساز فیلم به نمایش خلاقیت و استعدادهای دانش‌آموزان می‌پردازیم.
        این پلتفرم، به دانش‌آموزان امکان می‌دهد تا آثار خود را از جمله فیلم‌ها،
        مستندها، ویدئوها و سایر انواع آثار چندرسانه‌ای را به نمایش بگذارند.
        همچنین موسسات و ارگان ها می‌توانند آثار متناسب دانش آموزان را در این
        پلتفرم به اشتراک بگذارند. پیوسته با ما باشید تا زمینه‌ای برای رشد و
        توسعه استعدادهای هنری و آموزشی دانش‌آموزان فراهم کنیم!
      </p>
      <div className="flex flex-row gap-4 sm:flex-col md:flex-row">
        {BADGES.map((badge) => (
          <div key={badge.alt} className="h-[75px] w-[83px] cursor-pointer">
            <img
              className="h-full w-full rounded object-cover"
              src={badge.src}
              alt={badge.alt}
            />
          </div>
        ))}
      </div>
    </div>

    <hr className="my-6 border-gray-600" />

    <div className="md:flex md:flex-row-reverse md:justify-between">
      <div className="mt-6 flex flex-row justify-center gap-x-8 md:gap-x-6">
        {SOCIALS.map((social) => (
          <Link
            key={social.label}
            to={social.href}
            aria-label={social.label}
            target="_blank"
            rel="noopener noreferrer"
          >
            {social.render()}
          </Link>
        ))}
      </div>

      <div className="col-span-9 mt-6 text-xs leading-5 text-[#8c8c90] md:ml-6">
        <p>
          تماس با ما: تهران، بلوار کریمخان، خیابان سنایی، کوچه هشتم غربی، پلاک ۳
        </p>
        <p>
          شماره ثابت (پاسخگویی شنبه تا پنجشنبه ساعت ۹ الی ۱۶) :{" "}
          <span dir="ltr" className="inline-block">
            ۰۲۱-۸۸۸۶۳۷۵۳ ,۰۲۱-۸۸۳۲۳۷۴۹
          </span>
        </p>
        <p>شماره همراه (پاسخگویی همه روزه ۸ الی ۲۰): ۰۹۹۱۵۱۳۵۱۲۴</p>
      </div>
    </div>
  </footer>
);

export default Footer;
